import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Filter } from './filter-data.model';

@Injectable({
    providedIn: 'root',
})
export class FilterApplicationService {
    private filterSubject = new BehaviorSubject<Filter[] | null>(null);
    private nrOfResultsSubject = new BehaviorSubject<number | null>(null);

    changeFilters(filters: Filter[]): void {
        this.filterSubject.next(filters);
    }
    changeNrOfResults(nrOfResults: number): void {
        this.nrOfResultsSubject.next(nrOfResults);
    }
    $nrOfResults: Observable<number | null> =
        this.nrOfResultsSubject.asObservable();

    $filterSubject: Observable<Filter[] | null> =
        this.filterSubject.asObservable();

    constructor() {}
}
